'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var _ = require('underscore');
var styleHelper = require('../../helper/styleHelper');
var propConst = require('../../constants/propConst');


var SwitchIOS = React.createClass({

  propTypes: {
    isOpen: React.PropTypes.bool.isRequired
  },
  getInitialState: function () {
    return {
      isOpen: _.isUndefined(this.props.switchStatus) ? this.props.isOpen : (parseInt(this.props.switchStatus, 10) === -1),
      opacity: 1
    }
  },

  componentWillReceiveProps: function (newProps) {
    if (newProps.isOpen !== this.props.isOpen)
      this.setState({isOpen: _.isUndefined(newProps.switchStatus) ? newProps.isOpen : (parseInt(newProps.switchStatus, 10) === -1)})
  },

  render: function () {
    var isOpen = styleHelper.getStateProperty(this.props, propConst.IS_OPEN);
    var size = styleHelper.getSize(this.props);
    var stateStyle = {
      width: this.props.h,
      height: size.height
    };


    if (_.isUndefined(isOpen)) {
      isOpen = this.state.isOpen;
    }

    if (isOpen) {
      stateStyle.right = 0;
    } else {
      stateStyle.left = 0;
    }
    return (
      <div>
        <div className="component contents-layout border"
             style={{
                borderTopLeftRadius : size.height/2+ 'px 50%',
                borderTopRightRadius : size.height/2+ 'px 50%',
                borderBottomLeftRadius : size.height/2+ 'px 50%',
                borderBottomRightRadius : size.height/2+ 'px 50%',
                backgroundColor : isOpen ? '#5f5' : '#fff'
             }}
             onClick={this.onClick}>
        </div>
        <div ref="btn" className="button" style={stateStyle}></div>
      </div>
    );
  },

  onClick: function () {
    var ani;
    var isOpen = !this.state.isOpen;
    var w = styleHelper.getWidth(this.props);
    var h = this.props.h;
    var s = h;
    if (isOpen) {
      ani = {
        left: w - s
      }
    } else {
      ani = {
        left: 0
      }
    }
    $(ReactDOM.findDOMNode(this.refs.btn)).animate(ani, 150);
    this.setState({
      isOpen: isOpen
    });
  },

  componentDidMount: function () {
    $(ReactDOM.findDOMNode(this)).bind('itemClick', this.onClick);
  }
});


module.exports = SwitchIOS;



/** WEBPACK FOOTER **
 ** ./src/views/Components/SwitchIOS.jsx
 **/